/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/Spinner';
import ResearchExistingCMS64ReportHeader from './components/ResearchExistingCMS64ReportHeader';
import { tabHighLigther } from '../../../../../SharedModules/utilities/utilities';
import { handleScrollToEvent } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const ResearchExistingCMSReport = () => {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const errorMessagesData = useSelector(
    (state) => state.sharedState.CreateUtilizationTapeReducer.errorMessages
  );

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesData?.length > 0) {
      tabHighLigther('/research-exisitng-cms64report', true);
    } else {
      tabHighLigther('/research-exisitng-cms64report', false);
    }
  }, [JSON.stringify(errorMessagesData)]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  return (
    <div className="tabs-container tBillPanel custom-check">
      {spinnerLoader && <Spinner load={spinnerLoader} />}
      <CustomSeparator
        parent1="System"
        parent2="Technical Window"
        parent3="Online Fixes"
        parent4="Search Req Init Correct CMS64 Rpt"
      />

      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessagesData?.length > 0
              ? _.map(errorMessagesData, (l) => l.message)
              : []
          ),
        ]}
      />
      <ResearchExistingCMS64ReportHeader
        setSuccessMessages={setSuccessMessages}
        dispatch={dispatch}
      />
    </div>
  );
};
export default ResearchExistingCMSReport;
